<ion-row class="ion-wrap">
	@for (article of optionGroup.articles; track article) {
		@if (!isHidden(article)) {
			<ion-col size="6">
				<app-item-selectable-article
					(add)="onAdd(article)"
					(remove)="onRemove(article)"
					[article]="article"
					[currency]="currency"
					[group]="optionGroup"
					[preorderType]="preorderType"
					[selected]="count(article)"
					class="pointer"
				></app-item-selectable-article>
			</ion-col>
		}
	}
</ion-row>
